module.exports = __webpack_public_path__ + "img/elephants.1fa3ab43.jpg";